import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-dpe',
    templateUrl: './dpe.component.html',
    styleUrls: ['./dpe.component.scss']
})
export class DpeComponent {

    constructor(public dialogRef: MatDialogRef<DpeComponent>) {
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }
}
